import CustomScreenSaverDesktop from 'assets/images/custom-screensaver/custom-screensaver-desktop.png'
import CustomScreenSaverMobile from 'assets/images/custom-screensaver/custom-screensaver-mobile.png'
import CustomScreenSaverTablet from 'assets/images/custom-screensaver/custom-screensaver-tablet.png'

export const getPreLoadImages = () => {
  return [
    CustomScreenSaverMobile,
    CustomScreenSaverTablet,
    CustomScreenSaverDesktop,
  ]
}
